import { type CaptureUserContext } from '../ports/user-context';
import { getConfiguredUserContext } from './configuration';

// Late-binding delegate over the configured user-context getter, resolved per
// call so the engine always reads the host's current user.
export const captureUserContext: CaptureUserContext = {
  getCurrentUser: () => getConfiguredUserContext().getCurrentUser(),
  resolveCurrentUserRefId: () => getConfiguredUserContext().resolveCurrentUserRefId(),
};
